import { routerReducer } from 'react-router-redux';

import isLoading from './isLoading';
import appointments from './appointments';
import charting from './charting';
import session from './session';
import branches from './branches';
import practitioners from './practitioners';
import procedures from './procedures';

const rootReducer = {
    session,
    branches,
    practitioners,
    procedures,
    isLoading,
    appointments,
    charting,
    routing: routerReducer
};

export default rootReducer;


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/